import axios from 'axios';

export const defaultState = {
  dlqs: [],
};

export const mutations = {
  SET_IRE_DLQ_DATA(dlqState, data) {
    dlqState.dlqs = data;
  },
};

export const actions = {
  fetchIreDLQs({ commit }) {
    return axios.get(`${window.BASE_API.INVESTMENT_REPORTING_ENGINE}/dlqs`)
      .then(({ data }) => {
        commit('SET_IRE_DLQ_DATA', data);

        return data;
      })
      .catch((error) => {
        commit('SET_IRE_DLQ_DATA', []);

        return Promise.reject(error);
      });
  },
};

const ireDLQ = {
  state: defaultState,
  mutations,
  actions,
};

export default ireDLQ;



// WEBPACK FOOTER //
// ./src/store/ire/ireDLQ.js